const content: string = `default-src 'self'; script-src 'self' 'unsafe-eval' blob: *.intercom.io/ https://js.intercomcdn.com/ https://unpkg.com; style-src 'self' 'unsafe-inline' fonts.googleapis.com/ ; font-src 'self' fonts.gstatic.com/ fonts.intercomcdn.com/ ;img-src 'self' data: https://careaiq.azureedge.net/ ;frame-src *.okta.com/ https://api.office-integrator.com/ ;connect-src 'self' blob: *.okta.com/ ${process.env.USER_SVC_BASE_URL}/ ${process.env.AIQ_BASE_URL}/ *.intercom.io/ wss://nexus-websocket-a.intercom.io/ ${process.env.FASTAPI_CHAIN}/ ws://localhost:3001/ wss://dev.careaiq.com/aiq-svc/  https://api-iam.intercom.io/ http://localhost:3001/ http://localhost:8080/ ;worker-src 'self' blob:;`;

const setCSP = () => {
  const meta = document.createElement('meta');
  meta.httpEquiv = 'Content-Security-Policy';
  meta.content = content;
  document.head.appendChild(meta);
};

export default setCSP;
